/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetIdentityProviderConnectionSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetIdentityProviderConnectionRequest = {
  /**
   * Connection ID. Omit to fetch the organization's live connection.
   */
  id?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetIdentityProviderConnectionSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetIdentityProviderConnectionSecurity$outboundSchema:
  z.ZodMiniType<
    GetIdentityProviderConnectionSecurity$Outbound,
    GetIdentityProviderConnectionSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getIdentityProviderConnectionSecurityToJSON(
  getIdentityProviderConnectionSecurity: GetIdentityProviderConnectionSecurity,
): string {
  return JSON.stringify(
    GetIdentityProviderConnectionSecurity$outboundSchema.parse(
      getIdentityProviderConnectionSecurity,
    ),
  );
}

/** @internal */
export type GetIdentityProviderConnectionRequest$Outbound = {
  id?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetIdentityProviderConnectionRequest$outboundSchema: z.ZodMiniType<
  GetIdentityProviderConnectionRequest$Outbound,
  GetIdentityProviderConnectionRequest
> = z.pipe(
  z.object({
    id: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getIdentityProviderConnectionRequestToJSON(
  getIdentityProviderConnectionRequest: GetIdentityProviderConnectionRequest,
): string {
  return JSON.stringify(
    GetIdentityProviderConnectionRequest$outboundSchema.parse(
      getIdentityProviderConnectionRequest,
    ),
  );
}
